import toolbar from "./toolbar.jsx";

export default function (editor, opts = {}) {

  const em = editor.getModel();

  const module = new toolbar(editor, opts);

  em.get("modules").push(module);
  if (module.onLoad) em.get("toLoad").push(module);
}
